export type TRadiusMode = 'square' | 'rounded'

class BorderRadiusStorage {
  private readonly RADIUS_KEY = 'borderRadius'
  private readonly DEFAULT_RADIUS: TRadiusMode = 'square'

  public getRadius(): TRadiusMode {
    try {
      const raw = localStorage.getItem(this.RADIUS_KEY)
      return raw === 'rounded' ? 'rounded' : this.DEFAULT_RADIUS
    } catch (error) {
      console.error('Ошибка при чтении настройки скругления углов:', error)
      return this.DEFAULT_RADIUS
    }
  }

  public setRadius(radius: TRadiusMode): void {
    try {
      localStorage.setItem(this.RADIUS_KEY, radius)
    } catch (error) {
      console.error('Ошибка при сохранении настройки скругления углов:', error)
    }
  }
}

export const borderRadiusStorage = new BorderRadiusStorage()
